<div class="flex flex-col gap-5">
  <ul role="list" class="grid grid-cols-1 gap-3 sm:grid-cols-2">
    @for (method of methods; track method.id) {
    <li>
      <button type="button" (click)="selectMethod(method.id)" [attr.aria-pressed]="selectedMethod() === method.id"
        class="relative flex h-full w-full items-start gap-3.5 rounded-xl border p-5 text-left transition-all"
        [class]="selectedMethod() === method.id ? 'border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card hover:border-foreground/30'">
        <span class="min-w-0">
          <span class="block font-heading text-base font-bold leading-tight text-foreground">{{ method.name }}</span>
          <span class="mt-1 block text-sm leading-relaxed text-muted-foreground">{{ method.description }}</span>
        </span>
      </button>
    </li>
    }
  </ul>

  @switch (selectedMethod()) {
  @case ('later') {
  <div class="rounded-xl border border-border bg-muted p-5">
    <p class="m-0 font-heading text-base font-bold text-foreground">Add creators whenever you're ready</p>
    <p class="m-0 mt-1 text-sm leading-relaxed text-muted-foreground">Your brief will be saved and ready.
      Open it from Manage Brief to add creators and start monitoring at any time.</p>
  </div>
  }
  @case ('one') {
  <div class="rounded-lg border border-border bg-card p-3.5">
    <div class="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h3 class="font-heading text-base font-bold leading-none tracking-tight">Creators</h3>
        <p class="mt-1 text-sm text-muted-foreground">Each row needs a name and an Instagram or TikTok handle.</p>
      </div>
      <button (click)="addRow()" type="button"
        class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-1.5 self-start shrink-0">
        Add row
      </button>
    </div>
    <div class="overflow-x-auto rounded-lg border border-border">
      <table class="min-w-full divide-y divide-border">
        <thead class="bg-muted/50">
          <tr>
            <th scope="col" class="py-3 pr-3 pl-4 text-left text-xs font-semibold text-foreground">Creator name</th>
            <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-foreground">Instagram</th>
            <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-foreground">TikTok</th>
            <th scope="col" class="py-3 pr-4 pl-3 text-right text-xs font-semibold text-foreground">
              <span class="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border bg-card">
          @for (creator of rows(); track $index) {
          <tr>
            <td class="py-3 pr-3 pl-4 text-sm">
              <input type="text" [value]="creator.creatorName"
                (input)="updateRow($index, 'creatorName', $any($event.target).value)" placeholder="Creator name"
                class="input-primary w-full text-sm text-primary" />
            </td>
            <td class="px-3 py-3 text-sm">
              <input type="text" [value]="creator.instagram"
                (input)="updateRow($index, 'instagram', $any($event.target).value)" placeholder="handle"
                class="input-primary w-full text-sm text-primary" />
            </td>
            <td class="px-3 py-3 text-sm">
              <input type="text" [value]="creator.tiktok"
                (input)="updateRow($index, 'tiktok', $any($event.target).value)" placeholder="handle"
                class="input-primary w-full text-sm text-primary" />
            </td>
            <td class="py-3 pr-4 pl-3 text-right">
              <button (click)="removeRow($index)" type="button" class="btn-shout btn-shout-xs btn-shout-alert shrink-0"
                [attr.aria-label]="'Remove creator row ' + ($index + 1)">
                Remove
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
  @case ('csv') {
  <div class="flex flex-col gap-4">
    <div class="flex flex-row items-center justify-between gap-3">
      <div>
        <h3 class="font-heading text-base font-bold">Creator file</h3>
        <p class="mt-1 text-sm text-muted-foreground">Upload a CSV. Creators are added to this brief's group after it is created.</p>
      </div>
      <button type="button" (click)="getTemplate()"
        class="btn-shout btn-shout-xs btn-shout-secondary shrink-0">Get template</button>
    </div>
    <atom-add-document (documentUploaded)="onDocumentUploaded($event)"></atom-add-document>
    @if (createMonitoringService.uploadedCsvUrl()) {
    <p class="text-xs text-muted-foreground">File attached.</p>
    }
  </div>
  }
  @case ('shout') {
  <div class="flex flex-col gap-2.5">
    @if (groups().length) {
    @for (group of groups(); track group.id) {
    <button type="button" (click)="selectGroup(group)"
      class="flex w-full items-center gap-3.5 rounded-lg border p-3.5 text-left transition-colors"
      [class]="createMonitoringService.selectedList()?.id === group.id ? 'border-2 border-brand-studio bg-brand-studio/10 ring-2 ring-brand-studio/25' : 'border-border bg-card hover:border-foreground/30'">
      <span class="min-w-0 flex-1">
        <span class="block font-heading text-base font-bold leading-tight">{{ group.groupName }}</span>
        <span class="mt-1 block text-xs text-muted-foreground">
          {{ group.numberOfCreators || 0 }} {{ (group.numberOfCreators || 0) === 1 ? 'creator' : 'creators' }}
          @if (group.createdDate) {
          · {{ group.createdDate | date:'dd/MM/yyyy' }}
          }
        </span>
      </span>
    </button>
    }
    } @else {
    <p class="rounded-lg border border-border bg-card p-8 text-center text-sm text-muted-foreground">No creator groups yet.</p>
    }
  </div>
  }
  }

  @if (selectedMethod() === 'later') {
  <p class="m-0 text-sm font-semibold text-brand-studio-dark dark:text-brand-studio">You can add creators after submitting.</p>
  } @else if (tally()) {
  <p class="m-0 text-sm font-semibold text-brand-studio-dark dark:text-brand-studio">
    {{ tally() }} {{ tally() === 1 ? 'creator' : 'creators' }} ready to monitor
  </p>
  }
</div>
